/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Wizard Product Offerings StepDate Sagas
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.10.0
 */

import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { wizardStorageUpdateStepAction } from '../../modules/wizard/wizardActions';
import { TWizardMetaSuccessAction, TWizardNextSuccessAction } from '../../modules/wizard/wizardTypes';
import { productOfferingsSetParamsAction } from './wizardProductOfferingsActions';
import {
    makeSelectProductOfferingsDateFrom,
    makeSelectProductOfferingsDateTo,
} from './wizardProductOfferingsSelectors';

/*
* -------------------------------------------
*       INIT WIZARD WITH CURRENT STEP
* -------------------------------------------
*/

export function* productOfferingsStepSelectDateInitSaga(action: TWizardMetaSuccessAction): SagaIterator {
    yield call(productOfferingsStepSelectDateLoadParams, action.payload.step);
}

/*
* -------------------------------------------
*       LOAD DATA FOR NEXT STEP
* -------------------------------------------
*/

export function* productOfferingsStepSelectDateNextSuccessSaga(action: TWizardNextSuccessAction): SagaIterator {
    yield call(productOfferingsStepSelectDateLoadParams, action.payload.nextStep?.step);
}

export function* productOfferingsStepSelectDateLoadParams(stepMeta: any): SagaIterator {
    yield put(productOfferingsSetParamsAction({
        productOfferings: stepMeta.productOfferings || [],
        subsCount: stepMeta.subsCount || 0,
    }));
}

export function* productOfferingsStepSelectDateUpdateStorageSaga(): SagaIterator {
    const dateFrom = yield select(makeSelectProductOfferingsDateFrom());
    const dateTo = yield select(makeSelectProductOfferingsDateTo());

    yield put(wizardStorageUpdateStepAction({ dateFrom, dateTo }));
}
